/* eslint-disable no-template-curly-in-string */
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import languageValues from 'utils/LanguageUtils';
import SnackbarUtils from 'utils/SnackbarUtils';
import { closeModal } from '../../store/modules/ModalActions';
import { indexOfObject } from '../../utils/ArrayUtils';
import { typeIsImage } from '../../utils/FileUtils';
import { getMergedClassNames } from '../../utils/HTMLUtils';
import { getUniqueKey } from '../../utils/NumberUtils';
import { Col } from '../Col';
import { GenericModal } from '../GenericModal';
import { Row } from '../Row';
import FileItem, {
  UPLOAD_STATUS_DONE,
  UPLOAD_STATUS_ERROR,
  UPLOAD_STATUS_UPLOADING,
  UPLOAD_STATUS_WAITING,
} from './FileItem';
import styles from './NewCustomUploader.scss';
const rootClassName = styles.rootClassName;

const INITIAL_STATE = {
  uploading: true,
  fileList: [],
  uploadingIndex: -1,
  freezed: false,
};

// 25MB
const FILE_SIZE_LIMIT = 25 * 1000000;
// 10MB
const IMAGE_SIZE_LIMIT = 10 * 1000000;

class NewCustomUploader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...INITIAL_STATE,
    };

    this.onChanged = this.onChanged.bind(this);
    this.toClose = this.toClose.bind(this);
    this.getFileList = this.getFileList.bind(this);
    this.addToUploadQueue = this.addToUploadQueue.bind(this);
    this.toRemoveFiles = this.toRemoveFiles.bind(this);
    this.toCoverByPath = this.toCoverByPath.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.setState({
      ...this.state,
      fileList: this.getFileListOfProps(),
    });
  }

  getFileListOfProps() {
    let fileList = [];
    this.props.fileList.map((file, index) => {
      if (file.caminho && file.caminho.length) {
        file.status = UPLOAD_STATUS_DONE;
      }
      fileList.push(file);
      return index;
    });
    return fileList;
  }

  uploadIsLocked() {
    return this.state.fileList.length >= this.getFilesLimit() ? true : false;
  }

  getFilesLimit() {
    return this.props.filesLimit || 3;
  }

  toClose() {
    this.props.closeModal(this.props.modalKey);
  }

  onChanged() {
    if (typeof this.props.onChanged === 'function') {
      this.props.onChanged(this.state.fileList);
    }
  }

  getCurrCoverIndex() {
    let fileIndex = -1;
    this.state.fileList.forEach((file, index) => {
      if (file.principal) {
        fileIndex = index;
      }
    });
    return fileIndex;
  }

  getFirstImageIndex() {
    let fileIndex = -1;
    this.state.fileList.forEach((file, index) => {
      if (typeIsImage(file.tipo)) {
        fileIndex = index;
      }
    });
    return fileIndex;
  }

  toCoverByPath(caminho) {
    const newFileList = this.state.fileList.map((f) => {
      return {
        ...f,
        principal:
          caminho &&
          (caminho === f.caminho || this.state.fileList.length === 1),
      };
    });
    if (
      newFileList.length &&
      (!caminho || !newFileList.some((f) => f.principal))
    ) {
      newFileList[0].principal = true;
    }
    this.setState(
      {
        ...this.state,
        fileList: newFileList,
      },
      () => {
        this.onChanged();
      }
    );
  }

  getFileList() {
    return (
      <div className={rootClassName + '-file-list row'}>
        {this.state.fileList.map((file) => {
          const fileProps = {
            file,
            toRemove: this.toRemoveFiles,
            toCover: this.toCoverByPath,
            status: file.status,
            freezed: this.state.freezed,
            disabled: this.props.disabled,
          };
          return (
            <FileItem {...fileProps} key={file.caminho ?? getUniqueKey()} />
          );
        })}
      </div>
    );
  }

  getChangedFilePropsByIndex(index, newProps) {
    let newFileList = [...this.state.fileList];
    newFileList[index] = {
      ...newFileList[index],
      ...newProps,
    };
    return newFileList;
  }

  onUploadSuccess(index, response) {
    const dataIsString = typeof response.data === 'string';
    const caminho = dataIsString ? response.data : response.data.caminho;

    this.setState(
      {
        ...this.state,
        fileList: this.getChangedFilePropsByIndex(index, {
          caminho: caminho,
          caminhoCompressed: dataIsString
            ? undefined
            : response.data.caminhoCompressed,
          status: UPLOAD_STATUS_DONE,
          file: null,
        }),
      },
      () => {
        if (this.getCurrCoverIndex() > -1) {
          this.toCoverByPath();
        } else {
          this.toCoverByPath(caminho);
        }
        this.toUploadNewFiles();
      }
    );
  }

  onUploadError(index) {
    const newId = getUniqueKey();
    this.setState(
      {
        ...this.state,
        freezed: false,
        fileList: this.getChangedFilePropsByIndex(index, {
          status: UPLOAD_STATUS_ERROR,
          id: newId,
        }),
      },
      () => {
        this.toCoverByPath(newId);
        this.toUploadNewFiles();
      }
    );
  }

  onUploadProgress(index, response) {
    this.setState({
      ...this.state,
      fileList: this.getChangedFilePropsByIndex(index, {
        percent: response.percent,
      }),
    });
  }

  toRemoveFiles(caminho) {
    const toRemoveFromList = () => {
      let newFileList = [...this.state.fileList];
      const fileIndex = indexOfObject(newFileList, 'caminho', caminho);
      newFileList.splice(fileIndex, 1);
      if (!newFileList.some((f) => f.principal) && newFileList.length) {
        const index = newFileList.findIndex((f) => typeIsImage(f.tipo));
        if (index >= 0) {
          newFileList[index].principal = true;
        }
      }
      this.setState(
        {
          ...this.state,
          freezed: false,
          fileList: newFileList,
        },
        () => {
          this.props.onChanged(newFileList);
        }
      );
    };
    this.setState({
      ...this.state,
      freezed: true,
    });
    if (String(caminho).indexOf('__') === -1) {
      this.props
        .toRemove(caminho)
        .then(() => {
          toRemoveFromList();
        })
        .catch((error) => {
          this.toCoverByPath();
          SnackbarUtils.enqueueSnackbar({
            message:
              error.response.statusText ||
              this.props.languageValues.imageRemoveError,
            options: {
              variant: 'error',
            },
          });
        });
    } else {
      toRemoveFromList();
    }
  }

  toUploadNewFiles() {
    const newFileIndex = this.state.fileList
      .map((file) => file.status)
      .indexOf(UPLOAD_STATUS_WAITING);
    let newFile;
    if (newFileIndex > -1) {
      newFile = this.state.fileList[newFileIndex];
      this.setState({
        ...this.state,
        freezed: true,
        fileList: this.getChangedFilePropsByIndex(newFileIndex, {
          status: UPLOAD_STATUS_UPLOADING,
        }),
      });
      this.props.toUpload(
        newFile,
        (response) => {
          this.onUploadSuccess(newFileIndex, response);
        },
        (error) => {
          this.onUploadError(newFileIndex, error);
        },
        (response) => {
          this.onUploadProgress(newFileIndex, response);
        }
      );
    } else {
      this.setState({
        ...this.state,
        freezed: false,
      });
    }
  }

  getLockedLabel() {
    return this.props.languageValues.imageUploadLimitExeeded
      .split('${1}')
      .join(this.getFilesLimit());
  }

  getUnlockedLabel() {
    return this.props.languageValues.uploadAreaText;
  }

  getInputLabel() {
    if (this.uploadIsLocked()) {
      return this.getLockedLabel();
    }
    return this.getUnlockedLabel();
  }

  getValidFiles(files = []) {
    const list = Array.from(files)
      .filter((f) => {
        const extension = f.name.toLowerCase().split('.').pop();
        if (['png', 'jpg', 'jpeg'].includes(extension)) {
          return f.size < IMAGE_SIZE_LIMIT;
        }
        return f.size < FILE_SIZE_LIMIT;
      })
      .filter((f) => {
        return (
          !this.props.acceptedTypes.length ||
          this.props.acceptedTypes.some((at) =>
            String(f.name).toLowerCase().endsWith(at.toLowerCase())
          )
        );
      })
      .map((f) => this.props.getNewFileObject(f));
    return list;
  }

  addToUploadQueue(files) {
    if (
      Array.from(files).some((f) => {
        const extension = f.name.toLowerCase().split('.').pop();
        if (['png', 'jpg', 'jpeg'].includes(extension)) {
          return f.size > IMAGE_SIZE_LIMIT;
        }
        return f.size > FILE_SIZE_LIMIT;
      })
    ) {
      SnackbarUtils.enqueueSnackbar({
        message: languageValues.toasts.error.imageVideoSize,
        options: {
          variant: 'error',
        },
      });
    }
    if (
      Array.from(files).some(
        (f) =>
          this.props.acceptedTypes.length &&
          this.props.acceptedTypes.every(
            (at) => !String(f.name).toLowerCase().endsWith(at.toLowerCase())
          )
      ) &&
      typeof this.props.onTypeMismatch === 'function'
    ) {
      this.props.onTypeMismatch();
    }
    const validFiles = this.getValidFiles(files);
    const totalUploadedFiles = this.state.fileList.length;
    const limitToUpload =
      this.getFilesLimit() -
      (totalUploadedFiles > this.getFilesLimit()
        ? this.getFilesLimit()
        : totalUploadedFiles);
    let totalToUploadFiles =
      validFiles.length > limitToUpload ? limitToUpload : validFiles.length;
    let newFileList = [];
    let i;
    if (totalToUploadFiles > 0) {
      for (i = 0; i < totalToUploadFiles; ++i) {
        if (i < totalToUploadFiles) {
          newFileList.push({
            ...validFiles[i],
            status: UPLOAD_STATUS_WAITING,
          });
        }
      }
      const merged = [...this.state.fileList, ...newFileList];
      if (!merged.some((f) => f.principal) && merged.length) {
        const index = merged.findIndex((f) => typeIsImage(f.tipo));
        if (index >= 0) {
          merged[index].principal = true;
        }
      }
      this.setState(
        {
          ...this.state,
          fileList: merged,
        },
        () => {
          this.toUploadNewFiles();
        }
      );
    }
    if (validFiles.length > totalToUploadFiles) {
      SnackbarUtils.enqueueSnackbar({
        message: this.getLockedLabel(),
        options: {
          autoHideDuration: 6000,
          variant: 'warning',
        },
      });
    }
  }

  render() {
    return (
      <>
        <GenericModal
          onClose={this.state.uploading ? () => this.toClose() : undefined}
          title={this.props.languageValues.upload}
          DialogProps={{
            disableBackdropClick: this.state.freezed ? true : false,
            disableEscapeKeyDown: this.state.freezed ? true : false,
          }}
          titleHint={this.props.titleHint}
        >
          <Row>
            <Col cols={[12, 12, 12, 12, 12]}>
              <div
                className={getMergedClassNames([
                  rootClassName + '-drop-zone-container',
                  this.uploadIsLocked() ? rootClassName + '-locked' : '',
                  this.state.freezed ? rootClassName + '-freezed' : '',
                  this.props.disabled ? rootClassName + '-disabled' : '',
                ])}
              >
                {this.getInputLabel()}
                <input
                  className={rootClassName + '-upload-input'}
                  type='file'
                  accept={
                    this.props.acceptedTypes
                      ? this.props.acceptedTypes.join(', ')
                      : []
                  }
                  onChange={(event) => {
                    this.addToUploadQueue(event.target.files);
                  }}
                  disabled={
                    this.props.disabled ||
                    this.state.freezed ||
                    this.uploadIsLocked()
                  }
                  multiple
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col cols={[12, 12, 12, 12, 12]}>{this.getFileList()}</Col>
          </Row>
        </GenericModal>
      </>
    );
  }
}

NewCustomUploader.propTypes = {
  disabled: PropTypes.bool,
  modalKey: PropTypes.string.isRequired,
  getNewFileObject: PropTypes.func.isRequired,
  toUpload: PropTypes.func.isRequired,
  toRemove: PropTypes.func,
  fileList: PropTypes.array.isRequired,
  filesLimit: PropTypes.number,
  onChanged: PropTypes.func,
  titleHint: PropTypes.string,
  acceptedTypes: PropTypes.arrayOf(PropTypes.string),
  onTypeMismatch: PropTypes.func,
};

NewCustomUploader.defaultProps = {
  acceptedTypes: [],
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      closeModal,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(NewCustomUploader);
